export const REQUEST_SUBMITTED = 'REQUEST_SUBMITTED';
export const API_ERROR = 'API_ERROR';
export const SET_HISTOGRAM_DATA = 'SET_HISTOGRAM_DATA';
export const SET_SUMMARY_DATA_FA = 'SET_SUMMARY_DATA_FA';
export const SET_SUMMARY_DATA_LA = 'SET_SUMMARY_DATA_LA';
export const SET_TREND_DATA = 'SET_TREND_DATA';
export const SET_ASIN_DATA = 'SET_ASIN_DATA';



// WEBPACK FOOTER //
// ./src/components/spotcp/actions/actionTypes.jsx